<div class="top-menu-button">
    <button mat-icon-button (click)="openMenu()" *ngIf="!isShowBackButton else showbackbutton">
        <img src="{{licenceService.getKey('icon-top-menu')}}">
    </button>
    <ng-template #showbackbutton>
        <button mat-icon-button (click)="goBack()">
            <mat-icon class="white-icon">arrow_back_ios</mat-icon>
        </button>
    </ng-template>
</div>